import React, { useEffect } from "react";
import { useState } from "react";
import { LocationChoice, OtherLocation, TaskChoices } from "../forms/FormControls";
import TaskTakeFiveQuestions from "./TakeFiveQuestions";
import './TakeFive.css';
import { handleChange, fieldInvalid, TakeFiveFormState, enableValidation, resetValidation } from "./TakeFiveFormState";
import { SingleLineTextInput } from "../forms/FormControls";
import { Button } from 'reactstrap';
import {
    takeFiveFormState as fs
} from "./TakeFiveFormState";
import { Hazard, NewTaskTakeFive, TaskTakeFiveModel } from "../../../shared/models/api/models";
import { questionsUnanswered } from "../forms/util";
import { addTaskTakeFive } from "../../../shared/services/railOperationalFormsApi";
import Modal from "./Modal";
import { Hazards } from "./Hazards";
import { useNavigate } from "react-router-dom";
import { overview, takeFivePath } from "./TakeFiveRoutes";
import { FormModal, FormModalPaddedBody, FormModalSubHeader, ModalButton, ModalButtonRow } from "../../ui/FormModal";
import { InfoOutlined as InfoIcon, Warning as WarningIcon } from '@mui/icons-material';
import { ToolTipButton } from "../../menu/Labels";

const toolTip = {
    riskLevel: <><b>Risk Score Determination:</b><br />
        To generate a risk score, click the <b>Hazards</b> button below and add a Hazard Form.<br />The risk score is calculated using a 5x5 risk assessment matrix that combines Consequence<br /> Level (1-5) and Likelihood Level (1-5).<br /><br />
        <b>Background Color Meaning:</b><br />
        <b style={{ color: 'green' }}>Green</b> = Low Risk (score ≤ 10) - Default color for Take 5s with 0 or more low risk hazards<br />
        <b style={{ color: 'red' }}>Red</b> = High Risk (score &gt; 10, H11 or higher - Indicates a JHA must be completed before commencing the task)<br /></>
}

const MainForm = () => {
    const q = TaskTakeFiveQuestions;
    const [form, setForm] = useState({} as NewTaskTakeFive);
    const [showOtherLocation, setShowOtherLocation] = useState(false);
    const [highRisk, setHighRisk] = useState('No');

    useEffect(() => {
        const sub = fs.subscribe((t: TakeFiveFormState) => {
            setForm(t.form);

            setShowOtherLocation(t.form.locationId === OtherLocation.value);

            t.form.taskHazards?.forEach((h: Hazard) => {
                if (h.riskScore && Number(h.riskScore) > 10) {
                    setHighRisk('Yes');
                }
            });
        });

        return () => { sub.unsubscribe(); };
    }, []);

    useEffect(() => {
        const sub = fs.subscribe((t: TakeFiveFormState) => {
            setForm(t.form);

            setShowOtherLocation(t.form.locationId === OtherLocation.value);

            t.form.taskHazards?.forEach((h: Hazard) => {
                if (h.riskScore && Number(h.riskScore) > 10) {
                    setHighRisk('Yes');
                }
            });
        });

        return () => { sub.unsubscribe(); };
    }, [form.score]);

    return (
        <>
            <div className="main-form-row row-divider">
                <div className="question">{q.locationId.value}</div>
                <div className="answer">
                    <LocationChoice
                        onAnswerUpdate={handleChange(q.locationId.key)}
                        invalid={fieldInvalid(q.locationId.key)}
                    />
                </div>
            </div>

            {showOtherLocation &&
            <div className="main-form-row row-divider">
                <div className="question">{q.otherLocation.value}</div>
                <div className="answer">
                    <SingleLineTextInput
                        onAnswerUpdate={handleChange(q.otherLocation.key)}
                        invalid={fieldInvalid(q.otherLocation.key)}
                    />
                </div>
            </div>
            }

            <div className="main-form-row">
                <div className="question">{q.taskName.value}</div>
                <div className="answer">
                    <SingleLineTextInput
                        onAnswerUpdate={handleChange(q.taskName.key)}
                        invalid={fieldInvalid(q.taskName.key)}
                    />
                </div>
            </div>

            <div className="tf-details-tab-header">1. THINK THROUGH THE TASK</div>

            <div className="main-form-row row-divider main-form-row-view">
                <div className="question">{q.taskScopeUnderstood.value}</div>
                <div className="answer">
                    <TaskChoices
                        section={1}
                        name={q.taskScopeUnderstood.key}
                        onAnswerUpdate={handleChange(q.taskScopeUnderstood.key)}
                        invalid={fieldInvalid(q.taskScopeUnderstood.key)} />
                </div>
            </div>

            <div className="main-form-row row-divider main-form-row-view">
                <div className="question">{q.procedureExist.value}</div>
                <div className="answer take-five-radio-btn">
                    <TaskChoices
                        section={1}
                        name={q.procedureExist.key}
                        onAnswerUpdate={handleChange(q.procedureExist.key)}
                        invalid={fieldInvalid(q.procedureExist.key)} />
                </div>
            </div>

            <div className="main-form-row row-divider main-form-row-view">
                <div className="question">{q.taskStepsUnderstood.value}</div>
                <div className="answer take-five-radio-btn">
                    <TaskChoices
                        section={1}
                        name={q.taskStepsUnderstood.key}
                        onAnswerUpdate={handleChange(q.taskStepsUnderstood.key)}
                        invalid={fieldInvalid(q.taskStepsUnderstood.key)} />
                </div>
            </div>

            <div className="main-form-row row-divider main-form-row-view">
                <div className="question">{q.areToolsAndEquipmentsInGoodOrder.value}</div>
                <div className="answer take-five-radio-btn">
                    <TaskChoices
                        section={1}
                        name={q.areToolsAndEquipmentsInGoodOrder.key}
                        onAnswerUpdate={handleChange(q.areToolsAndEquipmentsInGoodOrder.key)}
                        invalid={fieldInvalid(q.areToolsAndEquipmentsInGoodOrder.key)} />
                </div>
            </div>

            <div className="main-form-row row-divider main-form-row-view">
                <div className="question">{q.correctPPE.value}</div>
                <div className="answer take-five-radio-btn">
                    <TaskChoices
                        section={1}
                        name={q.correctPPE.key}
                        onAnswerUpdate={handleChange(q.correctPPE.key)}
                        invalid={fieldInvalid(q.correctPPE.key)} />
                </div>
            </div>

            <div className="main-form-row row-divider main-form-row-view">
                <div className="question">{q.necessaryPermits.value}</div>
                <div className="answer take-five-radio-btn">
                    <TaskChoices
                        section={1}
                        name={q.necessaryPermits.key}
                        onAnswerUpdate={handleChange(q.necessaryPermits.key)}
                        invalid={fieldInvalid(q.necessaryPermits.key)} />
                </div>
            </div>

            <div className="main-form-row row-divider main-form-row-view">
                <div className="question">{q.clearPlan.value}</div>
                <div className="answer take-five-radio-btn">
                    <TaskChoices
                        section={1}
                        name={q.clearPlan.key}
                        onAnswerUpdate={handleChange(q.clearPlan.key)}
                        invalid={fieldInvalid(q.clearPlan.key)} />
                </div>
            </div>

            <div className="main-form-row main-form-row-view">
                <div className="question">{q.canRiskToHandsBeEliminated.value}</div>
                <div className="answer take-five-radio-btn">
                    <TaskChoices
                        section={1}
                        name={q.canRiskToHandsBeEliminated.key}
                        onAnswerUpdate={handleChange(q.canRiskToHandsBeEliminated.key)}
                        invalid={fieldInvalid(q.canRiskToHandsBeEliminated.key)} />
                </div>
            </div>

            <div className="tf-details-tab-header">2. SPOT THE HAZARDS</div>

            <div className="main-form-row row-divider main-form-row-view">
                <div className="question">{q.handsPlacedInVicinity.value}</div>
                <div className="answer take-five-radio-btn">
                    <TaskChoices
                        section={2}
                        name={q.handsPlacedInVicinity.key}
                        onAnswerUpdate={handleChange(q.handsPlacedInVicinity.key)}
                        invalid={fieldInvalid(q.handsPlacedInVicinity.key)} />
                </div>
            </div>

            <div className="main-form-row row-divider main-form-row-view">
                <div className="question">{q.equipmentGuardseRemoved.value}</div>
                <div className="answer take-five-radio-btn">
                    <TaskChoices
                        section={2}
                        name={q.equipmentGuardseRemoved.key}
                        onAnswerUpdate={handleChange(q.equipmentGuardseRemoved.key)}
                        invalid={fieldInvalid(q.equipmentGuardseRemoved.key)} />
                </div>
            </div>

            <div className="main-form-row row-divider main-form-row-view">
                <div className="question">{q.mobileEquipmentRisk.value}</div>
                <div className="answer take-five-radio-btn">
                    <TaskChoices
                        section={2}
                        name={q.mobileEquipmentRisk.key}
                        onAnswerUpdate={handleChange(q.mobileEquipmentRisk.key)}
                        invalid={fieldInvalid(q.mobileEquipmentRisk.key)} />
                </div>
            </div>

            <div className="main-form-row row-divider main-form-row-view">
                <div className="question">{q.areHazardousMaterialsInvloved.value}</div>
                <div className="answer take-five-radio-btn">
                    <TaskChoices
                        section={2}
                        name={q.areHazardousMaterialsInvloved.key}
                        onAnswerUpdate={handleChange(q.areHazardousMaterialsInvloved.key)}
                        invalid={fieldInvalid(q.areHazardousMaterialsInvloved.key)} />
                </div>
            </div>

            <div className="main-form-row row-divider main-form-row-view">
                <div className="question">{q.taskPerformedWithoutIsolationProcedure.value}</div>
                <div className="answer take-five-radio-btn">
                    <TaskChoices
                        section={2}
                        name={q.taskPerformedWithoutIsolationProcedure.key}
                        onAnswerUpdate={handleChange(q.taskPerformedWithoutIsolationProcedure.key)}
                        invalid={fieldInvalid(q.taskPerformedWithoutIsolationProcedure.key)} />
                </div>
            </div>

            <div className="main-form-row row-divider main-form-row-view">
                <div className="question">{q.workingAtHeights.value}</div>
                <div className="answer take-five-radio-btn">
                    <TaskChoices
                        section={2}
                        name={q.workingAtHeights.key}
                        onAnswerUpdate={handleChange(q.workingAtHeights.key)}
                        invalid={fieldInvalid(q.workingAtHeights.key)} />
                </div>
            </div>

            <div className="main-form-row row-divider main-form-row-view">
                <div className="question">{q.impactedByOtherActivity.value}</div>
                <div className="answer take-five-radio-btn">
                    <TaskChoices
                        section={2}
                        name={q.impactedByOtherActivity.key}
                        onAnswerUpdate={handleChange(q.impactedByOtherActivity.key)}
                        invalid={fieldInvalid(q.impactedByOtherActivity.key)} />
                </div>
            </div>

            <div className="main-form-row main-form-row-view">
                <div className="question">{q.environmentalHnSHazards.value}</div>
                <div className="answer take-five-radio-btn">
                    <TaskChoices
                        section={2}
                        name={q.environmentalHnSHazards.key}
                        onAnswerUpdate={handleChange(q.environmentalHnSHazards.key)}
                        invalid={fieldInvalid(q.environmentalHnSHazards.key)} />
                </div>
            </div>

            <div className="tf-details-tab-header">3. ASSESS THE RISKS</div>

            <div className="main-form-row main-form-row-view">
                <div className="question">Is the risk level equal to/greater than H11?<ToolTipButton text={toolTip.riskLevel} /></div>
                <div className="answer">
                    <div className="risk-level" style={{ backgroundColor: highRisk === 'Yes' ? 'red' : 'green'  }}>
                        { highRisk }
                    </div>
                    {highRisk === 'Yes' &&
                        <div className="risk-level" style={{ backgroundColor: "orange" }}>
                            Your Take 5 is HIGH RISK and requires a JHA to completed before commencing your task.
                        </div>
                    }
                </div>
            </div>

            <div className="tf-details-tab-header">4. MAKE CHANGES</div>
            <div className="main-form-row main-form-row-view">
                <div className="question">Implement controls and review Take 5 if changes in the task occur</div>
            </div>

            <div className="tf-details-tab-header">5. DO THE TASK SAFELY</div>
        </>
    );
};

type ResultModalProps = {
    isOpen: boolean,
    closeAction: () => void,
    title?: string
}

const ResultModal = (props: ResultModalProps) => {

    return (
        <FormModal {...props} headingText={props.title ? `Task - ${props.title}` : "Task Take 5"}>
            <FormModalPaddedBody>
                <div className="modal-body-content-container">

                    <div className="modal-body-content">
                        <div className="p-2 pb-5">
                            <WarningIcon className="icon-score-high mr-4 mb-3" />
                            <div className="d-inline-block">
                                Please add hazard(s) where a No response in section 1 or a Yes response in section 2 is given before submitting.<br/>
                                Navigate to Hazard Form by clicking the Hazards button below.
                            </div>
                        </div>
                    </div>

                    <ModalButtonRow>
                        <ModalButton onClick={props.closeAction} text="OK" primaryButton={true} />
                    </ModalButtonRow>

                </div>
            </FormModalPaddedBody>
        </FormModal>
    );
}

export const TakeFiveFormContents = () => {
    const riskScoreThreshold = 10;
    const [loading, setLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [form, setForm] = useState({} as NewTaskTakeFive);
    const [displayAllRequired, setAllRequired] = useState(false);
    const [displayErrorSubmitting, setErrorSubmitting] = useState(false);
    const navigate = useNavigate();
    const [displayResultModal, setResultModal] = useState(false);

    // Modal
    const [open, setOpen] = useState(false);
    const showModal = () => setOpen(true);
    const hideModal = () => setOpen(false);

    const closeResults = () => {
        setResultModal(false);
    }

    useEffect(() => {
        const sub = fs.subscribe((t: TakeFiveFormState) => {
            setForm(t.form);
        });

        return () => { sub.unsubscribe(); };
    }, []);

    const onSubmit = async () => {
        enableValidation();
        setIsSubmitting(true);

        let takeFive = getTakeFiveFromCurrentForm();

        try {
            const result = await submitIfAble(takeFive);
            if (result.unansweredCount > 0 && !result.modalShown) {
                setAllRequired(true);
                setIsSubmitting(false);
            }
            if (result.modalShown) {
                setIsSubmitting(false);
            }
        }
        finally {
            // Any additional cleanup if needed
        }
    };

    const getTakeFiveFromCurrentForm = () => {
        let highRisk = false;
        form.taskHazards?.forEach((h: Hazard) => {
            if (h.riskScore && Number(h.riskScore) > riskScoreThreshold) {
                highRisk = true;
            }
        })

        let submitTakeFive = {} as TaskTakeFiveModel;
        submitTakeFive.locationId = form.locationId;
        submitTakeFive.otherLocation = form.locationId && form.locationId > 0 ? '-2' : form.otherLocation;
        submitTakeFive.taskName = form.taskName;
        submitTakeFive.taskScopeUnderstood = form.taskScopeUnderstood;
        submitTakeFive.procedureExist = form.procedureExist;
        submitTakeFive.taskStepsUnderstood = form.taskStepsUnderstood;
        submitTakeFive.areToolsAndEquipmentsInGoodOrder = form.areToolsAndEquipmentsInGoodOrder;
        submitTakeFive.correctPPE = form.correctPPE;
        submitTakeFive.necessaryPermits = form.necessaryPermits;
        submitTakeFive.clearPlan = form.clearPlan;
        submitTakeFive.canRiskToHandsBeEliminated = form.canRiskToHandsBeEliminated;
        submitTakeFive.handsPlacedInVicinity = form.handsPlacedInVicinity;
        submitTakeFive.equipmentGuardseRemoved = form.equipmentGuardseRemoved;
        submitTakeFive.mobileEquipmentRisk = form.mobileEquipmentRisk;
        submitTakeFive.areHazardousMaterialsInvloved = form.areHazardousMaterialsInvloved;
        submitTakeFive.taskPerformedWithoutIsolationProcedure = form.taskPerformedWithoutIsolationProcedure;
        submitTakeFive.workingAtHeights = form.workingAtHeights;
        submitTakeFive.impactedByOtherActivity = form.impactedByOtherActivity;
        submitTakeFive.environmentalHnSHazards = form.environmentalHnSHazards;
        submitTakeFive.riskLevelEqualOrGreaterThanH11 = highRisk;
        submitTakeFive.taskHazards = form.taskHazards || [];
        return submitTakeFive;
    }

    const submitIfAble = (takeFive: TaskTakeFiveModel) => {
        return submitTakeFive(takeFive);
    }

    const submitTakeFive = (takeFive: TaskTakeFiveModel) => {
        let unansweredCount = questionsUnanswered(takeFive);
        let modalShown = false;

        if (unansweredCount === 0) {
            // Check if hazards are required
            const section1No =
                takeFive.taskScopeUnderstood?.toString() === "2" ||
                takeFive.procedureExist?.toString() === "2" ||
                takeFive.taskStepsUnderstood?.toString() === "2" ||
                takeFive.areToolsAndEquipmentsInGoodOrder?.toString() === "2" ||
                takeFive.correctPPE?.toString() === "2" ||
                takeFive.necessaryPermits?.toString() === "2" ||
                takeFive.clearPlan?.toString() === "2" ||
                takeFive.canRiskToHandsBeEliminated?.toString() === "2";

            const section2Yes =
                takeFive.handsPlacedInVicinity?.toString() === "1" ||
                takeFive.equipmentGuardseRemoved?.toString() === "1" ||
                takeFive.mobileEquipmentRisk?.toString() === "1" ||
                takeFive.areHazardousMaterialsInvloved?.toString() === "1" ||
                takeFive.taskPerformedWithoutIsolationProcedure?.toString() === "1" ||
                takeFive.workingAtHeights?.toString() === "1" ||
                takeFive.impactedByOtherActivity?.toString() === "1" ||
                takeFive.environmentalHnSHazards?.toString() === "1";

            if ((section1No || section2Yes) && (!takeFive.taskHazards || takeFive.taskHazards.length === 0)) {
                setResultModal(true);
                modalShown = true;
                return { unansweredCount: 1, modalShown };
            }

            addTaskTakeFive(takeFive)
                .then(submitResults)
                .catch(errorResults);
        }
        return { unansweredCount, modalShown };
    }

    const submitResults = (res: Response) => {
        setIsSubmitting(false);

        if (res.status === 200) {
            fs.reset();
            resetValidation();
            setAllRequired(false);
            errorResults(undefined);
            navigate(`${takeFivePath}/${overview}`);
            return;
        }
    }

    const errorResults = (e: any) => {
        if (e !== undefined) {
            console.error(e);
        }
        setIsSubmitting(false);
        setErrorSubmitting(true);

    }

    return (
        <>
            <div className="tf-container">
                <div className="main-form-header">Enter all details and click submit</div>

                <MainForm />
                {open &&
                    <div style={{ padding: "2rem" }}>
                        <Modal open={open} onClose={hideModal}>
                            <Hazards open={open} onClose={hideModal}></Hazards>
                        </Modal>
                    </div>
                }

                <ResultModal isOpen={displayResultModal} closeAction={closeResults} title={form.taskName} />

                <div className="main-form-row form-end">
                    <div className={`invalid-feedback mandatory-details${displayAllRequired === true ? " show" : ""}`}>Please enter all mandatory details in the form.</div>
                    <div className="submit">
                        {isSubmitting ?
                        <>
                                <div className="modal fade show" role="dialog" tabIndex={-1}></div>
                                <div className="btns-container">
                                    <Button className="btn-primary disabled">Submitting...</Button>
                                </div>
                        </>
                        :
                        <>
                                <div className="btns-container">
                                    <Button className="btn-primary" onClick={() => { setOpen(true) }}>Hazards</Button> 
                                    <Button className="btn-primary btn-spacing" onClick={onSubmit}>Submit</Button>
                                </div>
                        </>
                        }
                    </div>
                </div>
            </div>
        </>
    );
};